<template>
  <div :class="{'content-wrapper':remove == false}">
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <app-breadcrumb
          v-if="remove == false"
          :page-title="$t('certificate_detail')"
          :directory="$t('datatables')"
          :icon="'grid'"
        />
      </div>
      <!-- <div class="col-sm-12 col-md-6 breadcrumb-side-button">
        <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
          <button
            type="button"
            class="btn btn-primary btn-with-shadow"
            data-toggle="modal"
            @click="openAddEditModal"
          >
            {{ $t("bid") }}
          </button>
        </div>
      </div> -->
    </div>
    <div class="card card-with-search border-0 card-with-shadow">
      <div class="text-justify">
        <app-tab :tabs="tabsHorizontal" type="horizontal" />
      </div>
    </div>
    <job-bid
      v-if="isAddEditModalActive"
      :table-id="tableId"
      @close-modal="closeAddEditModal"
    />
  </div>
</template>
<script>
import CopyButton from "../../../Demo/UI/CopyButton.vue";

export default {
  name: "Tabs",
  components: { CopyButton },
  props:{
    certificateId: Number,
    companyId: Number,
    remove: Boolean,
  },
  data() {
    return {
      icon: "settings",
      isAddEditModalActive: false,
      tabsHorizontal: [
        {
          icon: "info",
          name: "Details",
          component: "certificate-details",
          permission: "",
          props: {company_id:this.companyId, certificate_id:this.certificateId},
        },
        {
          icon: "link",
          name: "Forms",
          component: "certificate-forms",
          permission: "",
          props: {company_id:this.companyId, certificate_id:this.certificateId},
        },
        // {
        //   icon: "users",
        //   name: "Users",
        //   component: "job-users",
        //   permission: "",
        // },
        // {
        //   icon: "file-text",
        //   name: "Document",
        //   component: "job-document",
        //   permission: "",
        // },
        // {
        //   icon: "message-square",
        //   name: "Conversation",
        //   component: "job-chat",
        //   permission: "",
        // },

        // {
        //   icon: "message-circle",
        //   name: "Notes",
        //   component: "job-notes",
        //   permission: "",
        // },
        // {
        //   icon: "users",
        //   name: "Bids",
        //   component: "job-bids",
        //   permission: "",
        // },
      ],
    };
  },
  methods: {
    openAddEditModal() {
      this.isAddEditModalActive = true;
    },
    closeAddEditModal() {
      $("#demo-add-edit-Modal").modal("hide");
      this.isAddEditModalActive = false;
      this.searchAndSelectFilterOptions();
      this.reSetData();
    },
  },
  computed: {
    userList() {
      return this.$store.state.user.loggedInUser;
    },
  },
};
</script>
